import { PageHero, usePageMeta } from "@/components/blocks";

const SECTIONS = [
  {
    id: "privacy",
    title: "Privacy Policy",
    body: [
      "StrengthLeap collects only the information you choose to share through our assessment and contact forms — typically your name, contact details and coaching goals.",
      "This information is used solely to prepare and deliver coaching recommendations and to respond to your enquiries. We do not sell or share personal data with third parties for marketing.",
      "This policy will be expanded and reviewed by legal counsel before commercial launch.",
    ],
  },
  {
    id: "terms",
    title: "Terms of Service",
    body: [
      "StrengthLeap coaching programs are provided as personalized fitness and lifestyle guidance. Program content, schedules and pricing are confirmed individually following assessment.",
      "Website content is provided for general information and does not create a coach–client relationship until a program agreement is in place.",
      "These terms will be finalized and reviewed by legal counsel before commercial launch.",
    ],
  },
  {
    id: "disclaimer",
    title: "Medical Liability Disclaimer",
    body: [
      "StrengthLeap provides coaching support, not medical advice, diagnosis or treatment. Always consult a qualified medical professional before beginning any exercise program, particularly if you have an existing injury or medical condition.",
      "Where rehabilitation support is provided, it is designed to work alongside — never in place of — guidance from your physician or physiotherapist.",
    ],
  },
];

export default function Legal() {
  usePageMeta("Privacy, Terms & Disclaimer | StrengthLeap", "StrengthLeap legal information: privacy, terms of service and medical disclaimer.");
  return (
    <main className="bg-ink text-bone">
      <PageHero testid="legal-page" eyebrow="Legal" lines={["The fine print,", "kept simple."]} />
      <section className="px-6 pb-28 sm:px-10 lg:px-16">
        <div className="mx-auto max-w-[900px]">
          {SECTIONS.map((s) => (
            <div key={s.id} id={s.id} data-testid={`legal-${s.id}`} className="scroll-mt-32 border-t border-bone/15 py-14 first:border-t-0">
              <h2 className="font-display text-3xl font-black uppercase tracking-tight sm:text-4xl">{s.title}</h2>
              {s.body.map((p, i) => (
                <p key={i} className="mt-5 max-w-2xl text-sm leading-relaxed text-ash sm:text-base">
                  {p}
                </p>
              ))}
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
